module.exports = __webpack_public_path__ + "images/saaremaa/mapSa.png";